import useOnAnnotationCreateSignatureToolMode from './useOnAnnotationCreateSignatureToolMode';

export default useOnAnnotationCreateSignatureToolMode;